<template>
  <div class="Transcript" @click="exitFullscreen" :style="{
    'background': transcriptSettings.background,
    'color': transcriptSettings.color,
    'font-size': transcriptSettings.size + 'pt',
    'justify-content': transcriptSettings.justify
    }">
    <div v-for="(userMessage,key) in transcript" :key="key">
      <div>
        <UserMessage :userMessage="userMessage"></UserMessage>
      </div>
    </div>
  </div>
</template>

<script>

import UserMessage from '@/components/UserMessage.vue'

import { mapState } from 'vuex'

export default {
  name: 'Transcript',
  components: {
    UserMessage
  },
  data: function () {
    return {
      settings: {
        color: ''
      }
    }
  },
  props: {
  },
  computed: {
    ...mapState('room',[
      'transcript',
      'transcriptSettings'
    ])
  },
  watch: {
    transcript: function () {
      this.$nextTick(function () {
        this.$el.scrollTop = this.$el.scrollHeight
      })
    }
  },
  methods: {
    exitFullscreen: function () {
      if(document.fullscreenElement){
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE/Edge */
          document.msExitFullscreen();
        }
      }
    }
  },
  mounted: function () {
  }
}
</script>

<style lang="scss" scoped>

  .Transcript{

    background: var(--background);

    flex: 1;

    scroll-behavior: smooth;

    display: flex;
    flex-direction: column;

    overflow: auto;
    border: 1px solid lightgray;
    padding: 1em;
  }

  .Transcript:fullscreen{
    border: 0;
  }

  .Transcript > div {
    margin-bottom: 0.5em;
  }

</style>
